import { create } from 'zustand'

export const useCaseActionHistoryDrawerStore = create<{
  isOpen: boolean
  taskId?: number
  open: ({ taskId }: { taskId: number }) => void
  close: VoidFunction
}>((set) => ({
  isOpen: false,
  taskId: undefined,
  open: ({ taskId }: { taskId: number }) => set({ isOpen: true, taskId }),
  close: () => set({ isOpen: false }),
}))
